import { useState } from "react";
import { useCombobox } from "downshift";
import { InputBaseStyle, InputDropdownSingleRowProps, InputHelp } from ".";
import classNames from "classnames";

export default ({
  value,
  onChange,
  options,
  help,
  label,
  containerClass,
  className,
}: any) => {
  const [items, setItems] = useState<InputDropdownSingleRowProps[]>(
    options as InputDropdownSingleRowProps[]
  );

  const {
    isOpen,
    getToggleButtonProps,
    getLabelProps,
    getMenuProps,
    getInputProps,
    highlightedIndex,
    getItemProps,
    selectedItem,
  } = useCombobox({
    onInputValueChange({ inputValue }) {
      setItems(
        options.filter((i: InputDropdownSingleRowProps) => {
          return (
            !inputValue ||
            i?.label.toLowerCase().includes(inputValue?.toLowerCase())
          );
        })
      );
    },
    items,
    itemToString(item) {
      return item ? item.label : "";
    },
    onSelectedItemChange: ({ selectedItem }) => {
      onChange(selectedItem);
    },
    selectedItem: value,
  });

  return (
    <div
      className={`flex flex-col relative justify-start items-start gap-2 w-full ${containerClass}`}
    >
      {label && (
        <label
          {...getLabelProps()}
          className="text-left text-uw-primary font-medium"
        >
          {label}
        </label>
      )}
      <InputBaseStyle className={className} {...getInputProps()} />
      <ul
        {...getMenuProps()}
        className="absolute max-h-[50vh] bg-white overflow-y-scroll w-full top-16 z-10"
      >
        {isOpen &&
          items.map((item, index) => (
            <li
              className={classNames(
                highlightedIndex === index &&
                  "bg-uw-secondary text-uw-text-secondary",
                selectedItem === item && "font-bold",
                "py-2 px-3 shadow-sm flex flex-col cursor-pointer"
              )}
              key={item.id}
              {...getItemProps({ item, index })}
            >
              <span>{item.label}</span>
            </li>
          ))}
      </ul>
      {help && <InputHelp>{help}</InputHelp>}
    </div>
  );
};
